export const state = () => ({
  showLocation: process.env.SYSTEM === 'app',
  deviceType: null,
  deviceFingerprint: null,
  locationAllowed: true,
  cashoutEnabled: true,
  cashoutHistory: [],
  iframePage: '', //track last iframe
  tab: null,
  cashierOverlay: {
    isOpen: false,
    url: '',
    openNonce: 0
  },
  iframeActive: false,
  appState: true,
  appReady: false,
  operatingSystem: null,
  leftSidebarOpen: false,
  rightSidebarOpen: false,
  localAuthAt: null,
  homeSection: 'highlights',
  platform: 'web',
  authRedirectTo: null,
  currency: process.env.DEFAULT_CURRENCY,
  homeTab: null,
  statId: null,
  inplay: null,
  inplayTab: null,
  freebetCount: null,
  globals: {},
  globals_new: [],
  globalsNewLoaded: false,
  promotions_settings: {},
  promotionsSettingsLoaded: false,
  seguro_empate_insured_events: [],
  site_settings: {},
  siteSettingsLoaded: false,
  active_bonuses: [],
  activeBonusesLoaded: false,
  banners: [],
  bannersLoaded: false,
  selections: [],
  sports: [],
  country: null,
  betslipType: null,
  outrightMarketId: null,
  notifications:[],
  sportradarActive: null,
  betAssistId: null,
  openedModals: [],
  redirecting: false
})

export const getters = {

  // seguro combinada
  seguroCombinadaActiveCampaign(state) {
    const campaigns = _.get(state.promotions_settings, 'data.combo.campaigns', [])
    return campaigns.find(c => c.status === 'active') || null
  },
  seguroCombinadaConfig(state, getters) {
    return _.get(getters.seguroCombinadaActiveCampaign, 'settings')
  },
  seguroCombinadaPrizes(state, getters) {
    return _.get(getters.seguroCombinadaActiveCampaign, 'prizes')
  },
  seguroCombinadaPageId(state) {
    return _.get(state.promotions_settings, 'data.combo.page_id')
  },
  seguroCombinadaAcceptNotEligibleLegs(state, getters) {
    return !!_.get(getters.seguroCombinadaConfig, 'accept_not_eligible_legs', false)
  },
  seguroCombinadaOptedIn(state, getters) {
    const currentList = (state.auth.user && Array.isArray(state.auth.user.opted_in_promotions))
        ? state.auth.user.opted_in_promotions
        : []
    return currentList.some(p => p && p.page_id === getters.seguroCombinadaPageId)
  },

  // seguro empate
  seguroEmpatePromotionId(state) {
    return _.get(state.promotions_settings, 'data.single.id')
  },

  seguroEmpatePageId(state) {
    return _.get(state.promotions_settings, 'data.single.page_id')
  },

  seguroEmpateOptedIn(state, getters) {
    const page = _.get(state.promotions_settings, 'data.single.page')
    const pageId = getters.seguroEmpatePageId
    if (!pageId) return false
    if (_.has(page, 'requires_opt_in') && !_.get(page, 'requires_opt_in')) return true
    const currentList = (state.auth.user && Array.isArray(state.auth.user.opted_in_promotions))
        ? state.auth.user.opted_in_promotions
        : []
    return currentList.some(p => p && parseInt(p.page_id) === parseInt(pageId))
  },

  seguroEmpateRunningCampaigns(state) {
    const campaigns = _.get(state.promotions_settings, 'data.single.campaigns', [])
    return campaigns.filter((c) => {
      const status = _.get(c, 'status')
      return !status || (status !== 'scheduled' && status !== 'ended')
    })
  },

  seguroEmpateAllInsuredEventIds(state, getters) {
    return _.flatMap(getters.seguroEmpateRunningCampaigns, c => _.get(c, 'insured_event_ids', []))
  },
  seguroEmpateInsuredEventIds(state) {
    return state.seguro_empate_insured_events
  },

  seguroEmpateCampaignForBetId(state, getters) {
    return (betId) => {
      if (!betId) return null
      return getters.seguroEmpateRunningCampaigns.find((c) =>
          _.includes(_.map(_.get(c, 'insured_bet_ids', []), String), String(betId))
      ) || null
    }
  }

}

export const mutations = {
  openCashierOverlay(state, url) {
    state.cashierOverlay.isOpen = true
    state.cashierOverlay.url = url
    state.cashierOverlay.openNonce += 1
  },
  closeCashierOverlay(state) {
    state.cashierOverlay.isOpen = false
    state.cashierOverlay.url = ''
  },
  addModal(state, value) {
    state.openedModals.push(value);
  },
  removeModal(state, value) {
    state.openedModals = state.openedModals.filter(item => item !== value)
  },
  setBetAssistId(state, value) {
    state.betAssistId = value;
  },
  setNotifications(state,notifications){
    state.notifications = notifications;
  },
  setDeviceType(state, deviceType) {
    state.deviceType = deviceType;
  },
  setDeviceFingerprint(state, deviceFingerprint) {
    state.deviceFingerprint = deviceFingerprint;
  },
  setLocationAllowed(state, locationAllowed) {
    state.locationAllowed = locationAllowed;
  }, 
  setIframePage(state, iframePage) {
    state.iframePage = iframePage;
  },
  setOutrightMarketId(state, outrightMarketId) {
    state.outrightMarketId = outrightMarketId;
  },
  setCashoutHistory(state, bets) {
    state.cashoutHistory = bets;
  },  
  addCashoutHistory(state, bet_id) {
    state.cashoutHistory.push(bet_id)
  },
  setLocationStatus(state, status) {
    state.showLocation = status
  },
  setCashoutStatus(state, status) {
    state.cashoutEnabled = status
  },
  setBetSlipType(state, type) {
    state.betslipType = type
  },
  setAppState(state, active) {
    state.appState = active
  },
  setLocalAuthAt(state, date) {
    state.localAuthAt = date
  }, 
  setFreebetCount(state, freebetCount) {
    state.freebetCount = freebetCount
  },
  setInplayTab(state, sport) {
    state.inplayTab = sport
  },
  setInplayEvent(state, inplay) {
    state.inplay = inplay
  },  
  setHeaderTab(state, tab) {
    state.tab = tab
  },
  setAppReady(state, appReady) {
    state.appReady = appReady
  },
  setIframeStatus(state, iframeActive) {
    state.iframeActive = iframeActive
  },   
  setOperatingSystem(state, os) {
    state.operatingSystem = os
  },     
  setPlatform(state, platform) {
    state.platform = platform
  },   
  setGlobals(state, globals) {
    state.globals = globals
  },
  setGlobalsNew(state, globals) {
    state.globals_new = JSON.parse(JSON.stringify(globals))
    state.globalsNewLoaded = true
  },
  resetGlobalsNew(state) {
    state.globals_new = []
    state.globalsNewLoaded = false
  },
  setPromotionsSettings(state, promotions_settings) {
    state.promotions_settings = JSON.parse(JSON.stringify(promotions_settings))
    state.promotionsSettingsLoaded = true
  },
  resetPromotionsSettings(state) {
    state.promotions_settings = {}
    state.promotionsSettingsLoaded = false
    state.seguro_empate_insured_events = []
  },
  setSeguroEmpateInsuredEvents(state, eventIds) {
    state.seguro_empate_insured_events = _.uniq(
      _.filter(_.map(eventIds, (id) => parseInt(id)), (id) => !isNaN(id))
    )
  },
  /**
   * Record an event as insured the moment its bet is linked, so the match closes
   * to further insurance without re-fetching /api/cms/promotions/insurances.
   */
  addSeguroEmpateInsuredEvent(state, eventId) {
    const id = parseInt(eventId)
    if (isNaN(id) || _.includes(state.seguro_empate_insured_events, id)) return
    state.seguro_empate_insured_events = state.seguro_empate_insured_events.concat(id)
  },

  addSeguroEmpateInsuredBetId(state, { campaignUuid, betId }) {
    if (!campaignUuid || !betId) return
    const next = JSON.parse(JSON.stringify(state.promotions_settings || {}))
    const campaign = _.find(_.get(next, 'data.single.campaigns', []), c => c.uuid === campaignUuid)
    if (!campaign) return
    const ids = _.isArray(campaign.insured_bet_ids) ? campaign.insured_bet_ids.map(String) : []
    if (_.includes(ids, String(betId))) return
    campaign.insured_bet_ids = ids.concat(String(betId))
    state.promotions_settings = next
  },

  setSiteSettings(state, settings) {
    state.site_settings = settings
    state.siteSettingsLoaded = true
  },
  setActiveBonuses(state, bonuses) {
    state.active_bonuses = bonuses
    state.activeBonusesLoaded = true
  },
  setBanners(state, banners) {
    state.banners = banners
    state.bannersLoaded = true
  },
  setHomeSection(state, home) {
    state.homeSection = home
  },  
  setHomeTab(state, home) {
    state.homeTab = home
  },
  setStatId(state, id) {
    state.statId = id
  },
  setAuthRedirectTo(state, path) {
    state.authRedirectTo = path
  },
  openLeftSidebar(state, visibility) {
    state.leftSidebarOpen = visibility
  },
  openRightSidebar(state, visibility) {
    state.rightSidebarOpen = visibility
  },
  setSports(state, sports) {
    state.sports = sports
  },
  setSportradarActive(state, value) {
    state.sportradarActive = value;
  },
  setStreamingVisible(state, value) {
    state.isStreamingVisible = value;
  },
  setStreamingVideo(state, value) {
    state.streamingVideo = value;
  },
  setRedirecting(state, value) {
    state.redirecting = value
  },
  add(state, item) {
    console.log(item);
    state.selections.push(item)
  },
  remove(state, item) {
    console.log('state.selections', state.selections);
    state.selections = _.reject(state.selections, function(selection) {
      return  _.get(selection, 'outcome.id') === _.get(item, 'outcome.id');
    });
  },
  clear(state) {
    state.selections = []
  }
}


export const actions = {
  async loadGlobalsNew({ commit, state }) {
    if (!state.globalsNewLoaded) {
      try {
        const globalsNew = await this.$new_cms().get('/api/cms/content/menu')
        commit('setGlobalsNew', globalsNew.data)
      } catch (e) {
        console.error('Failed to load globals new:', e)
        commit('setGlobalsNew', [])
      }
    }
  },

  async loadPromotionsSettings({ commit, getters, state }) {
    if (!state.promotionsSettingsLoaded) {
      try {
        const promotionsSettings = await this.$new_cms().get('/api/cms/promotions/insurances')
        commit('setPromotionsSettings', promotionsSettings.data)
      } catch (e) {
        console.error('Failed to load promotions settings:', e)
        commit('setPromotionsSettings', {})
      }
      commit('setSeguroEmpateInsuredEvents', getters.seguroEmpateAllInsuredEventIds)
    }
  },

  async loadSiteSettings({ commit, state }) {
    if (!state.siteSettingsLoaded) {
      try {
        const siteSettings = await this.$new_cms().get('/api/cms/settings')
        commit('setSiteSettings', siteSettings.data)
      } catch (e) {
        console.error('Failed to load site settings:', e)
        commit('setSiteSettings', [])
      }
    }
  },

  async loadActiveBonuses({ commit, state }) {
    if (!state.activeBonusesLoaded) {
      try {
        const activeBonuses = await this.$new_cms().get('/api/cms/bonuses')
        commit('setActiveBonuses', activeBonuses.data.data)
      } catch (e) {
        console.error('Failed to load active bonuses:', e)
        commit('setActiveBonuses', [])
      }
    }
  }
};
